import React from 'react';
import { Collapse, Form } from 'antd';
import { Helmet } from 'react-helmet';
import { translate } from 'react-i18next';
import i18next from 'i18next';
import { get, pickBy } from 'lodash';

import NumberField from 'Parts/ui/components/fields/NumberField';
import CheckboxField from 'Parts/ui/components/fields/CheckboxField';
import CancelAndSaveButtons from '../../../../../dashboard/components/CancelAndSaveButtons';

import EventAdminCampaignSettingsTransactionsPanel_en from './locales/EventAdminCampaignSettingsTransactionsPanel_en.json';
import EventAdminCampaignSettingsTransactionsPanel_fr from './locales/EventAdminCampaignSettingsTransactionsPanel_fr.json';

import './EventAdminCampaignSettingsTransactionsPanel.less';

class EventAdminCampaignSettingsTransactionsPanel extends React.Component {
  constructor(props) {
    super(props);

    var _self = this;

    this.state = {
      isAttendeeInfoRequested: false
    };

    props.fetchEvent(props.campaign.id, true, { showLocation: true, showSettings: true })
      .then((payload) => {
        _self.setState({
          isAttendeeInfoRequested: get(payload, 'payload.settings.attendee.information.request', null) == 1
        });
      });

    i18next.addResourceBundle(
      'en',
      'EventAdminCampaignSettingsTransactionsPanel',
      EventAdminCampaignSettingsTransactionsPanel_en
    );
    i18next.addResourceBundle(
      'fr',
      'EventAdminCampaignSettingsTransactionsPanel',
      EventAdminCampaignSettingsTransactionsPanel_fr
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) this.props.form.resetFields();
  }

  handleSubmit = e => {
    e.preventDefault();

    const { props } = this,
        { form, campaign, updateEventSettings } = props,
        { validateFields, isFieldTouched } = form;

    validateFields({ force: true }, (err, allValues) => {
        if (!err) {
            const updatedValues = pickBy(allValues, (value, key) => isFieldTouched(key));

            let attendee = {
              information: {
                required: allValues.attendeeInfoRequested || false,
                email: allValues.attendeeInfoEmailRequested || false,
                username: allValues.attendeeInfoUsernameRequested || false,
              }
            }

            updatedValues.attendee = attendee;

            if (Object.keys(updatedValues) && Object.keys(updatedValues).length > 0) {
                let values = {
                    ...updatedValues,
                };
                updateEventSettings(campaign.id, values);
            }
        }
    });
  }

  handleCancel = () => {
    this.props.form.resetFields();
  };

  handleAttendeeInfoRequestedChange = (e) => {
    var _self = this;
//setFieldsValue
    _self.setState({
      isAttendeeInfoRequested: e.target.checked
    });

    if (!e.target.checked) {
      _self.props.form.setFieldsValue({
        attendeeInfoEmailRequested: false,
        attendeeInfoUsernameRequested: false,
      })
    }
  };

  render() {
    const { props, handleSubmit, handleCancel } = this,
      { t, form, campaign, event, isUpdateEventSettingsInProgress } = props,
      { Panel } = Collapse;

    const isCampaignInactive = campaign && (campaign.statusId === 5 || campaign.statusId === 3);

    return (
      <div className="EventAdminCampaignSettingsTransactionsPanel ant-form-horizontal ant-form-horizontal">
        <Helmet>
          <title>{t('page-title')}</title>
        </Helmet>
        <Collapse accordion bordered={false} defaultActiveKey={['1']}>
          <Panel header={t('page-title')} key="1">
            <Form className="EventAdminCampaignSettingsTransactionsForm" onSubmit={handleSubmit}>
                <div className="inputs">

                    <NumberField
                        label={t('available-ticket-label')}
                        form={form}
                        fieldId="ticketLimit"
                        fieldOptions={{
                            rules: [
                                // {
                                //   required: true,
                                //   message: t('available-ticket-required')
                                // },
                                {
                                    validator: (rule, value, callback) => {
                                    const _value = parseFloat(value);
                                    return _value >= 1 || isNaN(_value) ? callback() : callback(true);
                                    },
                                    message: t('number-minimum', { min: 1 })
                                }
                            ]
                        }}
                        initialValue={get(event, 'settings.ticket.limit', null)}
                        formatter={value => value.toString().replaceAll(/[^\d]/g, '')}
                    />
                    <p>{t('available-ticket-desc-1')} <span className="hightlightedText">{t('available-ticket-desc-2')}</span></p>
                    <p>{t('available-ticket-desc-3')}</p>

                    <CheckboxField
                        label={t('attendee-info-requested')}
                        form={form}
                        fieldId="attendeeInfoRequested"
                        initialValue={get(event, 'settings.attendee.information.request', null) == 1 ? true : false}
                        onChange={this.handleAttendeeInfoRequestedChange}
                    />

                    <p>{t('attendee-info-requested-desc')}</p>

                    <CheckboxField
                        label={t('attendee-info-email-requested')}
                        form={form}
                        fieldId="attendeeInfoEmailRequested"
                        initialValue={this.state.isAttendeeInfoRequested && get(event, 'settings.attendee.information.email', null) == 1 ? true : false}
                        disabled={!this.state.isAttendeeInfoRequested}
                    />

                    <p>{t('attendee-info-email-requested-desc')}</p>

                    <CheckboxField
                        label={t('attendee-info-username-requested')}
                        form={form}
                        fieldId="attendeeInfoUsernameRequested"
                        initialValue={this.state.isAttendeeInfoRequested && get(event, 'settings.attendee.information.username', null) == 1 ? true : false}
                        disabled={!this.state.isAttendeeInfoRequested}
                    />

                    <p>{t('attendee-info-username-requested-desc')}</p>

                </div>
                {!isCampaignInactive && <CancelAndSaveButtons isSavingInProgress={isUpdateEventSettingsInProgress} onClickCancel={handleCancel} />}
            </Form>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default translate('EventAdminCampaignSettingsTransactionsPanel')(EventAdminCampaignSettingsTransactionsPanel);
